// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".placeholder-text[data-v-e31c4d2c]  input::-webkit-input-placeholder{text-transform:none!important}.placeholder-text[data-v-e31c4d2c]  input::-moz-placeholder{text-transform:none!important}.placeholder-text[data-v-e31c4d2c]  input:-ms-input-placeholder{text-transform:none!important}.placeholder-text[data-v-e31c4d2c]  input::-ms-input-placeholder{text-transform:none!important}.placeholder-text[data-v-e31c4d2c]  input::placeholder{text-transform:none!important}", ""]);
// Exports
module.exports = exports;
